import React from 'react';
import { Button, Col, FormGroup, FormLabel, Modal, ModalProps, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, Formik } from 'formik';
import { object } from 'yup';

import { FormikControl } from '@components/Base';
import { yupCsvFile } from '@utils/yup';

import { IngestionCreatePayload } from './action';

export type IngestionFormValues = Pick<IngestionCreatePayload, 'dataCsv'>;

type FormFormProps = Pick<ModalProps, 'onHide'> & { title: string };

const FormForm = ({ onHide, title }: FormFormProps) => {
  const { t } = useTranslation();

  return (
    <Form>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup as={Row} className="mb-3" controlId="dataCsv">
          <FormLabel column sm={4}>
            {t('common:csvFile')}*
          </FormLabel>
          <Col sm>
            <FormikControl name="dataCsv" type="file" required />
          </Col>
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('confirmModal.cancel')}
        </Button>
        <Button type="submit" variant="primary">
          {t('common:save')}
        </Button>
      </Modal.Footer>
    </Form>
  );
}

type Props = ModalProps & {
  onSubmit: (values: IngestionFormValues) => void;
  title: string;
}

const IngestionFormModal = ({ onSubmit, title, ...props }: Props) => {
  const validationSchema = object({
    dataCsv: yupCsvFile(),
  });

  const initialValues: IngestionFormValues = {
    dataCsv: undefined,
  };

  return (
    <Modal {...props}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <FormForm onHide={props.onHide} title={title} />
      </Formik>
    </Modal>
  )
};

export { IngestionFormModal };
